/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SubscriberRefundSummary } from './subscriberRefundSummary';

export interface SubscriberRenewalRefund {
  amount?: number;
  boxId?: string;
  cpf?: number;
  dateRenewed?: Date;
  email?: string;
  gatewayId?: number;
  gatewayName?: string;
  paymentId?: number;
  pendingRefund?: boolean;
  personId?: number;
  personName?: string;
  refunds?: number;
  subscriberId?: number;
  subscriberRefunds?: Array<SubscriberRefundSummary>;
  subscriberRenewalId?: number;
  ticketId?: number;
  transactionId?: string;
  transition?: string;
}
